// extracted by mini-css-extract-plugin
export var blue = "_1z-h";
export var brand = "_1z-d";
export var darkGrey = "_1z-g";
export var disabled = "_1z-6";
export var disabledSubtle = "_1z-7";
export var error = "_1z-8";
export var green = "_1z-i";
export var grey = "_1z-f";
export var icon = "_1z-0";
export var inherit = "_1z-c";
export var lightGrey = "_1z-e";
export var orange = "_1z-k";
export var pink = "_1z-m";
export var primary = "_1z-1";
export var purple = "_1z-n";
export var quaternary = "_1z-4";
export var quinary = "_1z-5";
export var red = "_1z-l";
export var secondary = "_1z-2";
export var success = "_1z-b";
export var tertiary = "_1z-3";
export var warning = "_1z-9";
export var warningSecondary = "_1z-a";
export var white = "_1z-o";
export var yellow = "_1z-j";